<mat-chip-list>
	<mat-chip
		*ngFor="let sub of array.controls; let i = index"
		[color]="chipColorMap.get(sub.value.status)"
		[matTooltip]="sub.value.status"
		selected
		(click)="editSubdivision(i)"
	>
		{{ sub.value.name }}
		<mat-icon
			matChipRemove
			[guard]="canDeleteSubdivision(sub.value)"
			rpsharedConfirm="Delete subdivision?"
			(onConfirmed)="array.removeAt(i)"
			>cancel</mat-icon
		>
	</mat-chip>
	<mat-chip
		color="primary"
		class="add-subdivision-chip"
		(click)="addSubdivision()"
	>
		Add Subdivision
		<mat-icon matChipRemove>add</mat-icon>
	</mat-chip>
</mat-chip-list>
